<template>
  <section>
    <p class="title is-1">Unidades Inventario</p>

    <b-button
      type="primary"
      class="hoverable-button"
      @click="verhistorial('si')"
    >
      <b-icon icon="check-circle" />
      <span class="ml-2">Ver Disponible</span>
    </b-button>

    <b-button
      type="primary"
      class="hoverable-button"
      @click="verhistorial('no')"
    >
      <i class="mdi mdi-block-helper"></i>
      <span class="ml-2">Ver No Disponible</span>
    </b-button>

    <b-table
      striped hover
      :bordered="bordered"

      :data="movimientos"
      :paginated="isPaginated"
      :per-page="perPage"
      :current-page.sync="currentPage"
      :pagination-simple="isPaginationSimple"
      :pagination-position="paginationPosition"
      :default-sort-direction="'asc'"
      :pagination-rounded="isPaginationRounded"
      :sort-icon="sortIcon"
      :sort-icon-size="sortIconSize"
    >
      <b-table-column
        field="nombre"
        label="Nombre"
        sortable
        searchable
        v-slot="props"
      >
        {{ props.row.nombre }}
      </b-table-column>

      <b-table-column
        field="codigo"
        label="Codigo"
        sortable
        searchable
        v-slot="props"
      >
        {{ props.row.codigo }}
      </b-table-column>

      <b-table-column
        field="precioVenta"
        label="Precio Venta"
        sortable
        searchable
        v-slot="props"
      >
        {{ props.row.precioVenta }}
      </b-table-column>

      <b-table-column
        field="existencia"
        label="Cantidad"
        sortable
        searchable
        v-slot="props"
      >
        {{ props.row.existencia }}
      </b-table-column>

    </b-table>

    <b-loading
      :is-full-page="true"
      v-model="cargando"
      :can-cancel="false"
    ></b-loading>
  </section>
</template>
  
  <script>
import HttpService from "../../Servicios/HttpService";
import { NotificacionesMixin } from "../../components/mixins/NotificacionesMixin";

export default {
  mixins: [NotificacionesMixin],

  data: () => ({
    cargando: false,
    movimientos: [],
    isPaginated: true,
    isPaginationSimple: false,
    isPaginationRounded: true,
    paginationPosition: "bottom",
    defaultSortDirection: "desc", // Orden descendente inicial
    sortIcon: "arrow-down",
    sortIconSize: "is-medium",
    currentPage: 1,
    perPage: 15,
    disponible: "todos", // Por defecto, muestra todo
    bordered: true,
  }),

  mounted() {
    this.mostrarNotificacion(
      "info",
      `Por defecto se muestran todos los productos`
    );
    this.verhistorial("todos"); // Mostrar todo al cargar
    document.title = "Unidades Inventario";
  },

  methods: {
    verhistorial(disponible) {
      this.disponible = disponible;
      this.obtenerIngresos();
    },
    obtenerIngresos() {
      this.cargando = true;
      HttpService.obtenerConConsultas("productos.php", {
        accion: "cantidadesInventario",
        disponible: this.disponible,
      })
        .then((resultado) => {
          this.movimientos = resultado; // Llena la tabla con los datos obtenidos
          this.cargando = false;
        })
        .catch((error) => {
          console.error("Error al obtener datos:", error);
          this.cargando = false;
        });
    },
  },
};
</script>
  